import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeUser1 = ({autorizacUA, styles, handleClickSel1, handleClickSel2, handleClickSel3,
      handleClickSel4}) => {
        const a2001 = autorizacUA.findIndex( autorizac => autorizac === "2001" );
        const a2005 = autorizacUA.findIndex( autorizac => autorizac === "2005" );
        const a2010 = autorizacUA.findIndex( autorizac => autorizac === "2010" );
        const a2015 = autorizacUA.findIndex( autorizac => autorizac === "2015" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large users yellow icon"></i>
        USUARIOS
      </button>

      {a2001!==-1 &&
       <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
      {/* <button className="ui labeled icon button fluid" style={styles.dropdown}> */}
        <i className="large edit red icon"></i>
        Autorizaciones
      </button>
      }
      {a2005!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
      {/* <button className="ui labeled icon button fluid" style={styles.dropdown}> */}
        <i className="large user circle outline red icon"></i>
        Perfiles
      </button>
      }
      {a2010!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
        <i className="large users red icon"></i>
        Usuarios
      </button>
      }

      {a2015!==-1 &&
      <div>
      <Divider inverted />

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel4}>
        <i className="large user secret red icon"></i>
        Cambiar clave de acceso
      </button>
      </div>
      }

    </div>
  )
};

export default HomeUser1
